<template>
  <span class="input-group-append">
    <button type="button" class="btn btn-light-primary"
            :disabled="!tieneDocumento || cargando"

            :title="tieneDocumento ? 'Ver datos del voluntario' : 'Ingrese el DNI para consultar'"
            @click.prevent="consultar">
      <i class="fa p-0" :class="cargando ? 'fa-spinner fa-spin' : 'fa-id-card'"></i>
    </button>

    <b-modal :id="idModal" v-model="mostrar" size="lg" title="Datos del voluntario" ok-only ok-title="Cerrar"
             dialog-class="modal-dialog-scrollable">
      <div v-if="cargando" class="text-center py-8">
        <div class="spinner spinner-primary"></div>
      </div>

      <div v-else-if="voluntario && voluntario.encontrado">
        <div class="d-flex align-items-start mb-5">
          <div class="symbol symbol-50 symbol-light-primary mr-4">
            <span class="symbol-label">
              <i class="fa fa-user text-primary"></i>
            </span>
          </div>
          <div>
            <div class="font-weight-bolder font-size-h5 text-dark">{{ voluntario.nombresApellidos || "-" }}</div>
            <div class="text-muted">
              {{ voluntario.tipoDocumento || "Documento" }} {{ voluntario.documentoNumero || "-" }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-4" v-for="campo in campos" :key="campo.etiqueta">
            <div class="text-muted font-size-sm">{{ campo.etiqueta }}</div>
            <div class="font-weight-bold text-dark">{{ campo.valor }}</div>
          </div>
        </div>
      </div>

      <div v-else class="alert alert-custom alert-light-warning mb-0">
        <div class="alert-text">
          {{ mensaje || "No se encontró un voluntario con ese número de documento." }}
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
/**
 * Botón + modal para consultar la ficha del voluntario en web-transparencia-dev
 * por número de documento. Visible sólo para administradores y coordinadores.
 */
export default {
  name: "ConsultaVoluntario",
  props: {
    documento: { type: [String, Number], default: "" },
    mesaVotacionId: { type: [Number, String], required: true },
    procesoElectoralId: { type: [Number, String], required: true },
    turno: { type: [Number, String], default: 1 },
  },
  data() {
    return {
      mostrar: false,
      cargando: false,
      voluntario: null,
      mensaje: "",
    };
  },
  computed: {
    idModal() {
      return "modal-voluntario-" + this.turno + "-" + this.mesaVotacionId;
    },
    tieneDocumento() {
      return String(this.documento || "").trim().length > 0;
    },
    campos() {
      const v = this.voluntario || {};
      const region = this.textoConExtranjero(v.region, v.regionExtranjeroTexto);
      const regionVoto = this.textoConExtranjero(v.regionVoto, v.regionVotoExtranjeroTexto);
      return [
        { etiqueta: "Celular", valor: v.numeroCelular || "-" },
        { etiqueta: "Correo electrónico", valor: v.correoElectronico || "-" },
        { etiqueta: "Fecha de nacimiento", valor: this.formatoFecha(v.fechaNacimiento) },
        { etiqueta: "Edad", valor: v.edad != null ? String(v.edad) : "-" },
        { etiqueta: "Nacionalidad", valor: v.nacionalidad || "-" },
        { etiqueta: "Región", valor: region },
        { etiqueta: "Distrito", valor: v.distrito || "-" },
        { etiqueta: "Región de voto", valor: regionVoto },
        { etiqueta: "Militancia", valor: v.militanciaDescripcion || v.militanciaCodigo || "-" },
        { etiqueta: "Fue voluntario de Transparencia", valor: this.textoSiNo(v.fueVoluntarioTransparencia) },
        /*{ etiqueta: "Fecha de registro", valor: this.formatoFechaHora(v.fechaRegistro) },
        { etiqueta: "IP", valor: v.ip || "-" },*/
      ];
    },
  },
  methods: {
    textoSiNo(valor) {
      if (valor === true) return "Sí";
      if (valor === false) return "No";
      return "-";
    },
    textoConExtranjero(nombre, extranjero) {
      const partes = [];
      if (nombre) partes.push(nombre);
      if (extranjero) partes.push(extranjero);
      return partes.length ? partes.join(" / ") : "-";
    },
    aFecha(valor) {
      if (!valor) return null;
      const fecha = new Date(valor);
      return isNaN(fecha.getTime()) ? null : fecha;
    },
    pad(n) {
      return String(n).padStart(2, "0");
    },
    formatoFecha(valor) {
      const fecha = this.aFecha(valor);
      if (!fecha) return "-";
      return this.pad(fecha.getDate()) + "/" + this.pad(fecha.getMonth() + 1) + "/" + fecha.getFullYear();
    },
    formatoFechaHora(valor) {
      const fecha = this.aFecha(valor);
      if (!fecha) return "-";
      return this.formatoFecha(valor) + " " + this.pad(fecha.getHours()) + ":" + this.pad(fecha.getMinutes());
    },
    consultar() {
      if (!this.tieneDocumento || this.cargando) return;
      this.mostrar = true;
      this.cargando = true;
      this.voluntario = null;
      this.mensaje = "";
      this.$http
        .post(this.apiRoute("Ficha2026ErmLima", "GetVoluntarioPorDocumento"), {
          documentoNumero: String(this.documento || "").trim(),
          mesaVotacionId: Number(this.mesaVotacionId),
          procesoElectoralId: Number(this.procesoElectoralId),
        })
        .then(function (response) {
          this.cargando = false;
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.voluntario = response.body.data || { encontrado: false };
          this.mensaje = response.body.message || "";
        }, function (error) {
          this.cargando = false;
          this.mostrarMensajeExcepcionVueResource(error);
        });
    },
  },
};
</script>
